<template>
  <div class="forgot-password">
    <div class="d-flex align-center justify-center h-screen">
      <div class="form-container">
        <div class="title">
          <h2>{{ $t("forgotPasswordScreen.title") }}</h2>
        </div>
        <div class="forgot-password-form">
          <p class="sub-title">
            {{ $t("forgotPasswordScreen.subTitleFirst") }}
          </p>
          <p class="sub-title">
            {{ $t("forgotPasswordScreen.subTitleSecond") }}
          </p>
          <v-text-field
            v-model="email"
            :label="$t('forgotPasswordScreen.inputPlaceholder')"
            v-on:keyup.enter="isSubmitBtnDisabled ? '' : handleSubmit()"
            :class="{
              'd-none': emailSent,
            }"
          ></v-text-field>
          <v-row no-gutters justify="center">
            <v-btn
              type="submit"
              class="send-button"
              @click="handleSubmit"
              :disabled="isSubmitBtnDisabled && !emailSent"
              >{{
                emailSent
                  ? $t("forgotPasswordScreen.buttons.backToLogin")
                  : $t("forgotPasswordScreen.buttons.sendEmail")
              }}</v-btn
            >
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "ForgotPasswordScreen",
  components: {},
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      inputActive: false,
      email: "",
      emailSent: false,
      toastVisible: false,
    };
  },
  validations() {
    return {
      email: {
        required: required,
        email: email,
      },
    };
  },
  created() {},
  mounted() {},
  computed: {
    isSubmitBtnDisabled() {
      return this.v$.email.$invalid;
    },
  },
  methods: {
    ...mapActions({
      forgotPassword: "users/forgotPassword",
    }),

    handleSubmit() {
      if (!this.emailSent) {
        const forgotPasswordPayload = {
          email: this.email,
        };
        this.forgotPassword(forgotPasswordPayload)
          .then(() => {
            toast.success(this.$t("notifications.success.forgotPassword"));
            this.emailSent = true;
            this.email = "";
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  width: 100%;
  .form-container {
    background-color: white;
    padding: 32px 16px;
    border-radius: 8px;
    width: 520px;
    box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    .title {
      text-align: center;
      padding: 8px 32px;
      background-color: #ae2f27;
      color: #fff;
      border-radius: 8px;
      margin: -60px auto 0 auto;
      width: fit-content;
    }
    .sub-title {
      font-size: 14px;
      line-height: 1.4;
      margin-bottom: 15px;
    }
    .forgot-password-form {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
    }
    .send-button {
      background: #ae2f27;
      color: #fff;
      max-width: 300px;
      padding: 8px 32px;
    }
  }
}

@media (max-width: 756px) {
  .forgot-password {
    .form-container {
      width: unset;
    }
    .btn-row {
      flex-direction: column;
      justify-content: space-around;
      gap: 12px;
    }
  }
}
</style>
